import { RoomId, RoomLiveStatus } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const init = createAction("[Room Live Stream Status] Init");
export const destroy = createAction("[Room Live Stream Status] Destroy");

export const update = createAction(
  "[Room Live Stream Status] Update Event",
  props<{ roomId: RoomId; status: RoomLiveStatus }>()
);
